var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6942 6.92178C17.1349 6.48115 17.1349 5.76865 16.6942 5.33271C16.2536 4.89678 15.5411 4.89209 15.1052 5.33271L9.52705 10.9108L3.94424 5.32803C3.50361 4.8874 2.79111 4.8874 2.35518 5.32803C1.91924 5.76865 1.91455 6.48115 2.35518 6.91709L7.9333 12.4952L2.35049 18.078C1.90986 18.5187 1.90986 19.2312 2.35049 19.6671C2.79111 20.103 3.50361 20.1077 3.93955 19.6671L9.51768 14.089L15.1005 19.6718C15.5411 20.1124 16.2536 20.1124 16.6896 19.6718C17.1255 19.2312 17.1302 18.5187 16.6896 18.0827L11.1114 12.5046L16.6942 6.92178Z",
    fill: "#C5C5D3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.9211fb5877c8c7b028f7fcf4b46103c6.svg";
export { ForwardRef as ReactComponent };